import DetailTitle from "@/components/DetailTitle"
import styles from './index.module.scss'
import { Tag } from 'antd'
const SubjectTag = ({ tags }) => {
	return (
		<div>
			<DetailTitle title="Tag" />
			<div className={styles.tagBox}>
				{tags.map(tag => <Tag key={tag + '_tag'} color="volcano">{tag}</Tag>)}
			</div>
		</div>
	)
}
export default SubjectTag;